/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {OnAlertsUpdated} from "@modules/AlertsModule";
import {AlertStatus, DB_Alert, getAlertTitle} from "@app/app-shared/alert";
import {COLORS} from "@res/colors";
import {formatAlertDatetime} from "../pages/ui/alerts/util";
import {FONTS} from "@res/fonts";
import dayjs from "./dayjs";

type Props = {
    alerts?: DB_Alert<any>[],
    patient?: string
}

export class AlertHover
    extends BaseComponent<Props, {}>
    implements OnAlertsUpdated {

    __onAlertsUpdated() {
        this.forceUpdate();
    }

    render() {
        if (!this.props.alerts || !this.props.alerts.length)
            return null;

        return <div className={"ll_v_s"}>
            {this.props.alerts.map((alert: DB_Alert<any>, i: number) => {
                const bgColor = i % 2 === 0 ? COLORS.white : COLORS.neutral_light;
                const {date} = formatAlertDatetime(alert._created.auditAt.timestamp);
                const time = dayjs(alert._created.auditAt.timestamp).format("hh:mm A")
                return <div
                    key={alert._id}
                    style={{zIndex: 1, height: 40, width: 300, justifyContent: "space-between", display: 'flex', textAlign: 'left', backgroundColor: bgColor, padding: "0 5px", paddingRight: "4px"}}
                >
                    {alert.status === AlertStatus.OPEN ?
                        FONTS.semi_bold_14(getAlertTitle(alert)) :
                        FONTS.reg_14_secondary_dark(getAlertTitle(alert))}
                    <div style={{whiteSpace: 'nowrap'}}>
                        {FONTS.reg_11_secondary_dark(date)}
                        {FONTS.reg_11_secondary_dark("|", {margin: "0 5px"})}
                        {FONTS.reg_11_secondary_dark(time)}
                    </div>
                </div>;
            })}
        </div>;
    }
}
